import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HeaderType } from '../model/header-type.enum';
import { ReferenceHelper } from '../model/reference-helper.model';
import { Incident } from '../model/incident.model';

@Injectable({
  providedIn: 'root',
})

export class ReferencesService{
  private referenceModeNotifier$: Subject<ReferenceHelper> = new Subject<ReferenceHelper>();
  private refreshReportFormNotifier$: Subject<boolean> = new Subject<boolean>();
  private refreshIncidentFormNotifier$: Subject<boolean> = new Subject<boolean>();

  referenceNotify(referenceHelper: ReferenceHelper): void {
    this.referenceModeNotifier$.next(referenceHelper);
  }

  getReferenceModeNotification(): Observable<ReferenceHelper> {
    return this.referenceModeNotifier$.asObservable();
  }

  refreshReportFormNotify(): void {
    this.refreshReportFormNotifier$.next(true);
  }

  getRefreshReportFormNotification(): Observable<boolean> {
    return this.refreshReportFormNotifier$.asObservable();
  }

  refreshIncidentFormNotify(): void {
    this.refreshIncidentFormNotifier$.next(true);
  }

  getRefreshIncidentFormNotification(): Observable<boolean> {
    return this.refreshIncidentFormNotifier$.asObservable();
  }
}
